import { Link } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { ReturnIcon } from '../../assets/icons/Return'
import { TredingDownIcon } from '../../assets/icons/trending-down'
import { TrendingUpIcon } from '../../assets/icons/trending-up'
import { CardIconTitle } from '../../components/CardIconTitle/CardIconTitle'
import { GenericTable } from '../../components/GenericTable/GenericTable'
import { CardDashboard } from '../../components/CardDashboard/CardDashboard'
import { Loading } from '../../components/Loading/Loading'
import { DivTitle } from '../../components/TitlePage/TitlePage'
import { colors } from '../../theme'
import { WrapperCardsResumo } from '../Dashboard/DashBoard.style'
import {
  Div,
  DivTop,
  Span,
  Wrapper,
} from '../PredictionDetails/PredictionDetails.style'
import { WrapperTitle } from '../../layouts/LayoutTable/LayoutTable'
import { useSalesPeopleDetails } from './useSalesPeopleDetails'
import { TabelaVendas } from '../../components/TabelaVendas/TabelaVendas'

export function SalesPeopleDetails() {
  const { SalesPeopleResume, clientsDetails, clientsLow, isLoading } =
    useSalesPeopleDetails()

  return (
    <>
      <ToastContainer theme="dark" />
      <DivTop>
        <Link to="/vendedores">
          <ReturnIcon />
        </Link>
        <Span>Detalhamento</Span>
      </DivTop>
      <WrapperTitle>
        <DivTitle color={colors.primaryText} size={22}>
          {SalesPeopleResume?.nome}
        </DivTitle>
      </WrapperTitle>
      {isLoading ? (
        <Loading contrast={false} />
      ) : (
        <WrapperCardsResumo>
          <CardDashboard
            colorTitle={colors.white}
            color={colors.white}
            background={colors.grey200}
            total={SalesPeopleResume?.media120Dias}
          >
            Média 180 dias
          </CardDashboard>
          <CardDashboard
            colorTitle={colors.grey900}
            color={colors.primaryText}
            background={colors.surface}
            total={SalesPeopleResume?.ultimos30Dias}
            percentage={SalesPeopleResume?.percentualUltimos30Dias}
          >
            Últimos 30 dias
          </CardDashboard>
          <CardDashboard
            colorTitle={colors.grey900}
            color={colors.primaryText}
            background={colors.surface}
            total={SalesPeopleResume?.ultimos60Dias}
          >
            Últimos 60 dias
          </CardDashboard>
          <CardDashboard
            colorTitle={colors.grey900}
            color={colors.primaryText}
            background={colors.surface}
            total={SalesPeopleResume?.ultimos90Dias}
          >
            Últimos 90 dias
          </CardDashboard>
          <CardDashboard
            colorTitle={colors.grey900}
            color={colors.primaryText}
            background={colors.surface}
            total={SalesPeopleResume?.ultimos120Dias}
          >
            Últimos 120 dias
          </CardDashboard>
          <CardDashboard
            colorTitle={colors.grey900}
            color={colors.primaryText}
            background={colors.surface}
            total={SalesPeopleResume?.ultimos150Dias}
          >
            Últimos 150 dias
          </CardDashboard>
          <CardDashboard
            colorTitle={colors.grey900}
            color={colors.primaryText}
            background={colors.surface}
            total={SalesPeopleResume?.ultimos180Dias}
          >
            Últimos 180 dias
          </CardDashboard>
        </WrapperCardsResumo>
      )}
      <Div>
        <Wrapper size="48">
          <CardIconTitle
            icon={<TrendingUpIcon />}
            background={colors.secondary}
            title="Clientes em alta"
          />
          <GenericTable
            font="14px"
            spacing="88px"
            headers={[
              // 'ID',
              'Cliente',
              'Percentual',
              // 'Qtd.',
            ]}
          >
            {isLoading ? (
              <Loading contrast={false} />
            ) : (
              clientsDetails.map(details => (
                <tr key={details.id}>
                  {/* <td>{details.id}</td> */}
                  <td className="col2">{details.nome}</td>
                  <td className="col3">{details.percentual}%</td>
                  {/* <td className="col3">{details.quantidade}</td> */}
                </tr>
              ))
            )}
          </GenericTable>
        </Wrapper>
        <Wrapper size="48">
          <CardIconTitle
            icon={<TredingDownIcon />}
            background={colors.error}
            title="Clientes em baixa"
          />
          <GenericTable
            font="14px"
            spacing="88px"
            headers={[
              // 'ID',
              'Cliente',
              'Percentual',
              // 'Qtd.',
            ]}
          >
            {isLoading ? (
              <Loading contrast={false} />
            ) : (
              clientsLow.map(item => (
                <tr key={item.id}>
                  {/* <td>{item.id}</td> */}
                  <td className="col2">{item.nome}</td>
                  <td className="col3">{item.percentual}%</td>
                  {/* <td className="col3">{item.quantidade}</td> */}
                </tr>
              ))
            )}
          </GenericTable>
        </Wrapper>
      </Div>
      <TabelaVendas />
    </>
  )
}
